import type { Commit } from 'vuex';

export interface ITableParamsState {
  tableParams: {
    limit: number;
    offset: number;
    searchText: string;
    sortBy: string;
    sortDesc: boolean;
  };
}

const initialState = (): ITableParamsState => ({
  tableParams: {
    limit: 15,
    offset: 0,
    searchText: '',
    sortBy: '',
    sortDesc: false,
  },
});

export default class TableParamsState {
  state = initialState;

  mutations = {
    SET_TABLE_PARAMS(state: ITableParamsState, params: Partial<ITableParamsState['tableParams']>): void {
      state.tableParams = { ...state.tableParams, ...params };
    },

    RESET_TABLE_PARAMS(state: ITableParamsState): void {
      state.tableParams = initialState().tableParams;
    },
  };

  actions = {
    setTableParams({ commit }: { commit: Commit }, params: Partial<ITableParamsState['tableParams']>): void {
      commit('SET_TABLE_PARAMS', params);
    },

    resetTableParams({ commit }: { commit: Commit }): void {
      commit('RESET_TABLE_PARAMS');
    },
  };

  getters = {
    tableParams: (state: ITableParamsState): ITableParamsState['tableParams'] => state.tableParams,
    limit: (state: ITableParamsState): number => state.tableParams.limit,
    offset: (state: ITableParamsState): number => state.tableParams.offset,
    searchText: (state: ITableParamsState): string => state.tableParams.searchText,
    sortBy: (state: ITableParamsState): string => state.tableParams.sortBy,
    sortDesc: (state: ITableParamsState): boolean => state.tableParams.sortDesc,
  };
}
